import React from "react";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { BannerForm } from "pages/main/BannerManager/BannerForm";
import { getBanner, updateBanner } from "shared/api/BannerApi";

function BannerEdit() {
  const { bannerId } = useParams();
  const queryClient = useQueryClient();

  // 수정 대상 1건만 단일 조회한다(목록 전체 조회 대신).
  const {
    data: target = null,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["banner", bannerId],
    queryFn: () => getBanner(bannerId),
    enabled: Boolean(bannerId),
  });

  const updateBannerMutation = useMutation({
    mutationFn: updateBanner,
    onSuccess: (_, variables) => {
      // 단일 캐시는 즉시 반영하고, 목록 캐시는 무효화해 다음 조회 시 최신화.
      queryClient.setQueryData(["banner", variables.bannerId], (previous) =>
        previous ? { ...previous, ...variables.data } : previous,
      );
      queryClient.invalidateQueries({ queryKey: ["banners"] });
    },
  });

  const loadError = isError ? "배너 정보를 불러오지 못했습니다." : "";

  const initialValues = target
    ? {
        title: target.title || "",
        hide: Boolean(target.hide),
        start: target.start ? String(target.start).slice(0, 10) : "",
        end: target.end ? String(target.end).slice(0, 10) : "",
        imagePc: target.webImage || target.imageUrl || target.image || "",
        imageMob: target.mobileImage || target.webImage || "",
      }
    : null;

  return (
    <BannerForm
      mode="edit"
      initialValues={initialValues}
      loadedData={target || null}
      isLoading={isLoading}
      loadError={loadError}
      onSubmit={(data) =>
        updateBannerMutation.mutateAsync({
          bannerId,
          data: { ...target, ...data },
        })
      }
    />
  );
}

export default BannerEdit;
